export const isObject = (object): boolean =>
  typeof object === 'object' && object !== null && !Array.isArray(object);
